import { useEffect, useRef, useState } from 'react';
import { getMarketModelForwardCurveIds } from 'services/portfolios';
import { Skeleton } from '@chakra-ui/react';
import { PortfolioItemExtended } from 'types/portfolios';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { PCW_STEPS } from '../constants';
import { PortfolioItemSelectStep } from '../PortfolioItemSelectStep';
import mappedItemTypes from 'services/items/mappedItemTypes';
import { useWizardState } from 'components/wizard/hooks/useWizardState';

export interface ForwardCurvesStepFormData {
    selected?: PortfolioItemExtended[];
}

export function ForwardCurvesStep() {
    const mounted = useRef(false);
    const [loading, setLoading] = useState(true);
    const [defaultSelected, setDefaultSelected] = useState<string[]>([]);

    const { items } = useSelector((state: RootState) => state.portfolio);
    const { formData } = useWizardState();

    useEffect(() => {
        if (mounted.current) {
            return;
        }

        const init = async () => {
            setLoading(true);
            const selectedIds = new Set<string>();
            const marketModelId = formData?.[PCW_STEPS.PCW_PORTFOLIO_BASICS_STEP_ID]?.mainMarketModel;
            if (marketModelId) {
                try {
                    const marketModelIds = await getMarketModelForwardCurveIds(marketModelId);
                    marketModelIds.forEach((id) => selectedIds.add(String(id)));
                } catch {}
            }
            setDefaultSelected(Array.from(selectedIds));
        };

        init().finally(() => {
            setLoading(false);
            mounted.current = true;
        });
    }, [formData, items]);

    if (loading) {
        return <Skeleton height="40px" />;
    }

    return (
        <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_FORWARD_CURVES_STEP_ID}
            itemTypeIds={[mappedItemTypes.FORWARD_CURVE.id]}
            defaultSelectedIds={defaultSelected}
        />
    );
}
